export const callToActionInput =
  'Create your own AI Generated Profile Pictures!';

export const callToActionInputTShirt = 'Create your own AI Generated T-shirt!';
